/**
 * CMS landing page 的營運總覽 KPI。
 */

import { apiFetch } from './core';

/** GET /admin/dashboard/kpis — 營運總覽 4 個 KPI。 */
export interface DashboardKpis {
  /** 今日已付款訂單總額（numeric string） */
  today_sales: string;
  today_orders: number;
  devices_online: number;
  unack_p1: number;
  /** ISO 8601 server time */
  as_of: string;
}

export function getDashboardKpis(): Promise<DashboardKpis> {
  return apiFetch<DashboardKpis>('/admin/dashboard/kpis');
}
